"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var InvisibleInput = function InvisibleInput() {
  return /*#__PURE__*/_react["default"].createElement("input", {
    className: "invisible-input",
    readOnly: true,
    "data-sentry-component": "InvisibleInput",
    "data-sentry-source-file": "index.tsx"
  });
};
var _default = exports["default"] = InvisibleInput;